









import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";

@Component({
  model: {
    prop: "isExpand",
    event: "click"
  }
})
export default class ExpandControl extends Vue {
  @Prop({ default: "展开明细" })
  expandText: string;
  @Prop({ default: "收起明细" })
  closeText: string;
  @Prop({ default: false })
  isExpand: boolean;
  @Prop({ default: "top" })
  position: boolean;
  @Prop({ default: false, type: Boolean })
  onlyShowIcon: boolean;
  get $checked() {
    return this.isExpand;
  }
  handleExpandOrder() {
    this.$emit("click", !this.isExpand);
  }
}
